import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Home from "./pages/Home";
import Wiki from "./pages/Wiki";
import WikiArticle from "./pages/WikiArticle";
import WikiEditor from "./pages/WikiEditor";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";

function TrackVisit() {
  useEffect(() => {
    if (sessionStorage.getItem('to_visited')) return;
    sessionStorage.setItem('to_visited', '1');
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/visits`).catch(() => {});
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <TrackVisit />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/wiki" element={<Wiki />} />
              <Route path="/wiki/new" element={<WikiEditor />} />
              <Route path="/wiki/:slug/edit" element={<WikiEditor />} />
              <Route path="/wiki/:slug" element={<WikiArticle />} />
              <Route path="/profil/:userId" element={<Profile />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
